import { BodyMain } from '@justomx/atlas-design-system'
import { useScannerReader } from 'hooks/scanner.hook'

interface ScannerProps {
  onScan: (scanned: string) => void
}

export const ScannerMolecule = (props: ScannerProps) => {
  const { onScan } = props

  useScannerReader(onScan)

  return (
    <div className="flex flex-col gap-4 items-center">
      <BodyMain className="text-center">O ingresa con código QR</BodyMain>
      <BodyMain className="text-center text-[#9A9A9A]">
        Encuentra el código buscando tu nombre en la tablet y escanéalo con este
        dispositivo.
      </BodyMain>
    </div>
  )
}
